"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { FiActivity, FiCalendar, FiShoppingBag, FiTrash2 } from "react-icons/fi";
import { cx } from "@/lib/tailwind-utils";
import { ItemType } from "@/types/enums/item-type";
import { RegularCatalogShopCartLine } from "@/types/shop";
const iconByType = {
  [ItemType.SERVICE]: FiCalendar,
  [ItemType.PRODUCT]: FiShoppingBag,
  [ItemType.MEDICATION]: FiActivity
};
const labelByType = {
  [ItemType.SERVICE]: "Prepaid service",
  [ItemType.PRODUCT]: "Product",
  [ItemType.MEDICATION]: "Medication"
};
const CatalogCartRow: React.FC<{
  line: RegularCatalogShopCartLine;
  onReplace?: (line: RegularCatalogShopCartLine) => void;
  onRemove?: () => void;
}> = t0 => {
  const $ = _c(18);
  const {
    line,
    onRemove
  } = t0;
  const Icon = iconByType[line.itemType];
  const subtitle = line.snapshot.category || labelByType[line.itemType];
  let t1;
  if ($[0] !== Icon || $[1] !== line.snapshot.imageUrl || $[2] !== line.snapshot.name) {
    t1 = <div className="relative flex h-10 w-10 flex-none items-center justify-center overflow-hidden rounded-xl bg-background-secondary text-primary">{line.snapshot.imageUrl ? <img src={line.snapshot.imageUrl} alt={line.snapshot.name} loading="lazy" className="h-full w-full object-cover" /> : <Icon className="h-4 w-4" />}</div>;
    $[0] = Icon;
    $[1] = line.snapshot.imageUrl;
    $[2] = line.snapshot.name;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== line.snapshot.name) {
    t2 = <p className="truncate text-body-emphasis text-foreground">{line.snapshot.name}</p>;
    $[4] = line.snapshot.name;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== subtitle) {
    t3 = <p className="mt-0.5 truncate text-caption text-foreground-secondary">{subtitle}</p>;
    $[6] = subtitle;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = <div className="min-w-0 flex-1">{t2}{t3}</div>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== line.snapshot.name || $[12] !== onRemove) {
    t5 = onRemove && <button type="button" onClick={onRemove} aria-label={`Remove ${line.snapshot.name} from cart`} className={cx("flex h-8 w-8 flex-none cursor-pointer items-center justify-center rounded text-foreground-secondary transition-colors", "hover:bg-hover hover:text-status-error-text focus:outline-none focus-visible:ring-2 focus-visible:ring-primary")}><FiTrash2 className="h-3.5 w-3.5" /></button>;
    $[11] = line.snapshot.name;
    $[12] = onRemove;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t1 || $[15] !== t4 || $[16] !== t5) {
    t6 = <div className="group flex items-start gap-3">{t1}{t4}{t5}</div>;
    $[14] = t1;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
};
export default CatalogCartRow;